import React from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";

const ContentTable = ({ tableData, caption, footer, bordered }) => {
	const classes = useStyles("Content");
	return (
		<div
			itemScope=""
			itemType="https://schema.org/Table"
			className={classes.table}
		>
			<TableContainer
				className={bordered ? classes.tableBordered : ""}
				component={Paper}
				dangerouslySetInnerHTML={{
					__html: tableData?.replace(
						"<table>",
						`<table><caption>${caption}</caption>`
					),
				}}
			></TableContainer>
			<p className={classes.tableFooterText}>{footer}</p>
		</div>
	);
};

ContentTable.propTypes = {};
export default ContentTable;
